import { useLayoutEffect, useState } from 'react';

/** Width of the approved reference composition (design px). */
export const DESIGN_WIDTH = 1024;
/** Below this viewport width the fluid (tablet / mobile) layout is used. */
export const DESKTOP_MIN = 1024;
/** Never scale the composition wider than this (keeps everything from ballooning). */
export const MAX_CANVAS = 1200;
/** Hard cap so even huge monitors can't blow the design up visually. */
export const MAX_ZOOM = 1.1;

/**
 * Scales the 1024px reference composition to the viewport width so the desktop
 * render keeps the exact proportions/geometry of the approved screenshot — but
 * never larger than MAX_ZOOM, so the site reads at a sensible size on 1440/4K.
 */
export function useDesignZoom() {
  const [state, setState] = useState({ zoom: 1, desktop: true });

  useLayoutEffect(() => {
    const update = () => {
      const w = document.documentElement.clientWidth;
      const desktop = w >= DESKTOP_MIN;
      const target = Math.min(w, MAX_CANVAS) / DESIGN_WIDTH;
      const zoom = desktop ? Math.min(MAX_ZOOM, target) : 1;
      setState((s) => (s.zoom === zoom && s.desktop === desktop ? s : { zoom, desktop }));
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return state;
}
